<template>
    <div class="section-goods">
        <div class="section-goods__content">
            <div class="section-goods__header">
                <button v-if="time" @click="onBack" class="section-goods__back-btn">
                    <icon-arrow-left class="section-goods__back-btn-icon" />
                </button>
                <div class="section-goods__title">
                    Выберите товар <br>
                    для захвата <br>
                    нового региона
                </div>
            </div>
            <div class="section-goods__grid">
                <div class="section-goods__item section-goods__item-text-content">
                    <span class="section-goods__item-text">Ваша цель — захватить каждый регион новым товаром за 2 года.</span>
                </div>
                <div
                    class="section-goods__item"
                    v-for="good in allGoods" :key="good.id"
                    :class="`good--id-${good.id}`"
                >
                    <block-good
                        :id="good.id"
                        :title="good.title"
                        :disabled="!!goodById(good.id)"
                        @click="onSelect(good)"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex'

    export default {
        components: {},
        computed: {
            ...mapState('control', ['time']),
            ...mapState('goods', ['allGoods']),
            ...mapGetters('goods', ['goodById'])
        },
        methods: {
            ...mapActions('control', ['start']),
            onSelect (good) {
                this.$router.push({name: 'game-good', params: {id: good.id}})
            },
            onBack () {
                this.start()
                this.$router.push({name: 'game-runtime'})
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .section-goods {
        padding 0 6.3rem 0 6.3rem
        +layout-sm() {
            padding 0 2rem
        }
        +layout-xs() {
            height 100%
        }

        &__content {
            padding 3.6rem 0 5.3rem 0
            border-top 0.2rem solid #3665F3
            +layout-sm() {
                border-top 0 none
            }
            +layout-xs() {
                padding 1.8rem 0
            }
        }

        &__header {
            display flex
            margin-bottom 3.8rem
            align-items flex-start
            +layout-xs() {
                margin-top 5px
                margin-bottom 1.1rem
            }
        }

        &__title {
            font-size 3.4rem
            line-height 3.8rem
            font-weight $font-bold
            +layout-xs() {
                font-size 2rem
                line-height 2.4rem
            }
        }

        &__grid {
            display grid
            grid-template-columns repeat(4, 1fr)
            grid-gap 1.7rem 1.9rem
            +layout-sm() {
                grid-template-columns repeat(3, 1fr)
                grid-gap 1.3rem
            }
            +layout-xs() {
                grid-template-columns repeat(2, 1fr)
            }
        }

        &__back-btn {
            width 3.8rem
            height @width
            border-radius 50%
            display inline-flex
            justify-content center
            flex-shrink 0
            align-items center
            padding 0
            border 0
            color $color-accent
            background-color #3665F3
            cursor pointer
            transition background-color 0.3s ease, color 0.3s ease
            outline none
            user-select none
            margin-right 2.5rem
            +layout-xs() {
                width 2.9rem
                height 2.9rem
            }

            &:hover {
                background-color #2B0EAF
                color #382AEF
            }

            &:active {
                opacity 0.9
            }

            &-icon {
                width 1.2rem
                height 2rem
                position relative
                right 1px
                +layout-xs() {
                    width 0.9rem
                    height 1.6rem
                    top -0.2rem
                }
            }
        }

        &__item {
            display flex
            width 100%
            align-items center
            font-size 2rem
            line-height 2.4rem

            &-text-content {
                +layout-sm() {
                    grid-column 1 / -1
                }
                +layout-xs() {
                    margin-bottom 0.8rem
                }
            }

            &-text {
                margin-top -0.8rem

                +layout-sm() {
                    margin 0
                    line-height 1.8rem
                    font-size 1.5rem
                }
            }
        }
    }
</style>
